import { render, staticRenderFns } from "./0.vue?vue&type=template&id=309d4910&scoped=true&"
var script = {}
import style0 from "./0.vue?vue&type=style&index=0&id=309d4910&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309d4910",
  null
  
)

export default component.exports